import React from 'react';
import {useReport} from "../../../utilities/contexts/report-context";
import Table from "../../Queries/General/Table";
import TableHeader from "../../Queries/General/TableHeader";
import Th from "../../Queries/General/Printable/Th";
import CostsRow from "./CostsRow";
import EmptyQuery from "../../Queries/General/EmptyQuery";

const CostsTable = () => {

    const {costsData} = useReport();

    return (
        <div>
            {costsData.list && costsData.list.length > 0 ?
                <Table>
                    <TableHeader>
                        <Th>Nr Lotto</Th>
                        <Th>Provenienza</Th>
                        <Th>Articolo - Colore</Th>
                        <Th>Cliente</Th>
                        <Th>Resa</Th>
                        <Th>Costo Mq</Th>
                        <Th>Ve/Mq</Th>
                        <Th>Diff. %</Th>
                        <Th>N. Mq Vend.</Th>
                        <Th>Tot. costo</Th>
                        <Th>Tot. Vend.</Th>
                        <Th>Margine</Th>
                        <Th>Tot. Nr. Pz</Th>
                        <Th>Documento</Th>
                    </TableHeader>
                    <tbody>
                    {costsData.list.map((row,i) =>
                        <CostsRow row={row} key={i} />
                    )}
                    </tbody>
                </Table>
                :
                <EmptyQuery />
            }

        </div>
    );
};

export default CostsTable;